<template>
    <div class='flex-box bg-blue f-bd'>
        <div class="f16 hand" v-if="back" @click='goBack'><i class="el-icon-arrow-left mg-right3"></i>返回</div>
        <div class="flex-box-bd f18" style="letter-spacing:5px"><slot></slot></div>
        <a class="f-white" @click="$base.replaceTo('/pos/save')">首页</a>
    </div>
</template>

<script>
    export default {
        name: "myNav",
        props:{
            back: {
                default: true,
                type: Boolean,
            }
        },
        methods: {
            goBack() {
                this.$emit('onBack');
                this.$base.linkBack();
            },
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/myNav.vue